import i18n from "@/plugins/i18n.js";
import store from "@/store";

/**
 * - Description -
 * SettingsService contains all the methods that allows the webapp to adjust settings.
 *
 */
export default {
    name: "SettingsService",
    save: save,
    discard: discard,
};

function discard() {
    // Retrieve settings from Global State
    let settings = store.getters["UserState/getSettings"];
    // Restore the settings to the previous value
    settings = restoreToPrevious(settings);
    // Save to Global state
    store.dispatch("UserState/setSettings", settings);
}

function save() {
    // Retrieve settings from Global State
    let settings = store.getters["UserState/getSettings"];
    // Set the settings to the current value
    settings = setToCurrent(settings);
    // Filtering
    settings = addSettingsFilter(settings);
    // Save to the Global State the changes
    store.dispatch("UserState/setSettings", settings);
}


function setToCurrent(settings) {
    settings.email.enableEmailRouting.previous = settings.email.enableEmailRouting.current;
    settings.web.enableWebInformationRetrieval.previous = settings.web.enableWebInformationRetrieval.current;
    settings.imageCaptioning.enableImageCaptioning.previous = settings.imageCaptioning.enableImageCaptioning.current;
    settings.general.language.previous = settings.general.language.current;
    settings.chatbot.language.previous = settings.chatbot.language.current;
    settings.chatbot.audio.language.previous = settings.chatbot.audio.language.current;
    settings.chatbot.audio.enable.previous = settings.chatbot.audio.enable.current;
    settings.chatbot.engine.previous = settings.chatbot.engine.current;
    settings.chatbot.enableAdvanced.previous = settings.chatbot.enableAdvanced.current;
    settings.chatbot.enableWikipedia.previous = settings.chatbot.enableWikipedia.current;
    settings.chatbot.enableConsole.previous = settings.chatbot.enableConsole.current;
    i18n.locale = settings.general.language.current.locale;

    return settings;
}

function restoreToPrevious(settings) {
    settings.email.enableEmailRouting.current = settings.email.enableEmailRouting.previous;
    settings.web.enableWebInformationRetrieval.current = settings.web.enableWebInformationRetrieval.previous;
    settings.imageCaptioning.enableImageCaptioning.current = settings.imageCaptioning.enableImageCaptioning.previous;
    settings.general.language.current = settings.general.language.previous;
    settings.chatbot.language.current = settings.chatbot.language.previous;
    settings.chatbot.audio.language.current = settings.chatbot.audio.language.previous;
    settings.chatbot.audio.enable.current = settings.chatbot.audio.enable.previous;
    settings.chatbot.engine.current = settings.chatbot.engine.previous;
    settings.chatbot.enableAdvanced.current = settings.chatbot.enableAdvanced.previous;
    settings.chatbot.enableWikipedia.current = settings.chatbot.enableWikipedia.previous;
    settings.chatbot.enableConsole.current = settings.chatbot.enableConsole.previous;
    i18n.locale = settings.general.language.previous.locale;

    return settings;
}


function addSettingsFilter(settings) {
    settings.settingsFilter = [];
    if (!settings.email.enableEmailRouting.current) {
        settings.settingsFilter.push("admin-emailRouting");
    }
    if (!settings.web.enableWebInformationRetrieval.current) {
        settings.settingsFilter.push("admin-webInformationRetrieval");
    }
    if (!settings.imageCaptioning.enableImageCaptioning.current) {
        settings.settingsFilter.push("lab-imageAcquisition");
    }
    return settings;
}
